import { useRecoilState, useRecoilValue } from 'recoil';

import { COOKEY_KEY } from 'constants/cookieConstants';
import { THEME_TYPE } from 'constants/themeConstants';
import { themeTypeState } from 'state/atoms';
import { themeSelector } from 'state/selectors';
import { setCookie } from 'utils/cookieUtils';

const useTheme = () => {
  const [themeType, setThemeType] = useRecoilState(themeTypeState);
  const theme = useRecoilValue(themeSelector);

  const handleToggleTheme = () => {
    setThemeType((prevThemeType) => {
      const newTheme = prevThemeType === THEME_TYPE.DARK ? THEME_TYPE.LIGHT : THEME_TYPE.DARK;
      setCookie(COOKEY_KEY.THEME_TYPE, newTheme, {
        path: '/',
      });

      return newTheme;
    });
  };

  return {
    themeType,
    theme,
    onToggleTheme: handleToggleTheme,
  };
};

export default useTheme;
